import { createContext, useContext } from "react";

export const MenuContext = createContext({
  closeMenu: () => {},
});

export const useMenu = () => useContext(MenuContext);
